import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { buttonDestructive, infoLight10, neutralDark40, neutralLight40, success, warning } from "../../../constants/colors";
import { getFocusRingStyles } from "../../../util/focusRing";
import { withFocusToggleClassName } from "../../../util/withFocusClassName";
var styles = {
  error: {
    backgroundColor: buttonDestructive,
    fontColor: neutralLight40
  },
  info: {
    backgroundColor: infoLight10,
    fontColor: neutralDark40
  },
  success: {
    backgroundColor: success,
    fontColor: neutralDark40
  },
  warning: {
    backgroundColor: warning,
    fontColor: neutralDark40
  }
};
var getColor = function getColor(_ref) {
  var type = _ref.type;
  return styles[type].fontColor;
};
var getBackgroundColor = function getBackgroundColor(_ref2) {
  var type = _ref2.type;
  return styles[type].backgroundColor;
};
var focusRing = getFocusRingStyles({
  includeFocusPseudoClass: true,
  colorOverride: neutralDark40,
  offset: 4,
  radius: 4,
  theme: "light"
});
export var ToastStyled = withFocusToggleClassName(styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    min-height: 48px;\n    box-sizing: border-box;\n    display: flex;\n    align-items: flex-start;\n\n    color: ", ";\n    background-color: ", ";\n\n    font-weight: 500;\n    font-size: 14px;\n\n    ", "\n"])), getColor, getBackgroundColor, focusRing));
ToastStyled.displayName = "ToastStyled";
//# sourceMappingURL=ToastStyled.js.map